import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChatBubbleSlashRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1.825.977a.6.6 0 0 0-.848 0 .605.605 0 0 0-.002.85l13.2 13.2a.6.6 0 0 0 .848-.847l-2.418-2.418c1.11-1.08 1.792-2.547 1.792-4.165 0-3.312-2.865-6-6.4-6-1.577 0-3.02.535-4.135 1.42zM4.72 3.872A5.42 5.42 0 0 1 8 2.797c2.945 0 5.2 2.22 5.2 4.8 0 1.265-.543 2.443-1.44 3.315zm4.897 8.29A5.6 5.6 0 0 1 8 12.397a5.6 5.6 0 0 1-2.108-.41 1.2 1.2 0 0 0-.927.008l-1.463.627.45-.828a1.2 1.2 0 0 0-.12-1.33 4.53 4.53 0 0 1-1.03-2.867c0-.65.143-1.275.403-1.85l-.898-.895A5.7 5.7 0 0 0 1.6 7.597c0 1.36.482 2.615 1.297 3.622l-1.22 2.236a.637.637 0 0 0 .56.943q.15 0 .288-.053l2.91-1.248c.785.322 1.652.5 2.565.5.907 0 1.772-.178 2.555-.497z",
			fill: "#currentcolor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgChatBubbleSlashRegularIcon;
